import { TrustedDeviceType } from '../graphql-types';
import { BackendDateTimestamp } from '../helper/backend-frontend-conversion.helper';

export class TrustedDeviceEntity {
    public static readonly GqlFields: Array<keyof TrustedDeviceType> = [
        'id',
        'expiresAt',
        'userAgent',
        'createdAt',
        // 'token',
        // 'userId',
    ];
    public static fromBackend(res: TrustedDeviceType): TrustedDeviceEntity {
        /**
         * nichts davon ist nullable, das ist im gateway falsch typisiert
         */
        return new TrustedDeviceEntity(res.id, res.userAgent, BackendDateTimestamp(res.expiresAt), BackendDateTimestamp(res.createdAt));
    }
    constructor(
        public Id: number = null,
        public UserAgent: string = null,
        public ExpiresAt: Date = null,
        public CreatedAt: Date = null,
    ) {}
    public Clone(override: Partial<TrustedDeviceEntity> = {}): TrustedDeviceEntity {
        const attr = { ...this, ...override };
        return Object.assign(new TrustedDeviceEntity(), attr);
    }
}
